import { render } from "./MenuDepartment.vue?vue&type=template&id=46a46a3a&scoped=true"
import script from "./MenuDepartment.vue?vue&type=script&lang=js"
export * from "./MenuDepartment.vue?vue&type=script&lang=js"

import "./MenuDepartment.vue?vue&type=style&index=0&id=46a46a3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a46a3a"]])

export default __exports__